<script>
import {mapActions} from "vuex";

export default {
  name: "ExtendPaymentCallbacks",
  components: {},
  mixins: [],
  data () {
    return {
      enableLoader: true,
    }
  },
  computed: {},
  watch: {},
  created() {
    const token = this.$route.params.token;
    if (token) {
      this.update({charge_id: token}).then((result) => {
        if (result.code) {
          if (result.ex_code === 'attempted') {
            this.$router.push({ name: "ExtendPaymentAttempts", params: { token: token } });
          } else {
            this.$router.push({ name: "ExtendPaymentFailures", params: { token: token } });
          }
        } else {
          this.$router.push({ name: "ExtendPaymentCompletes", params: { token: token } });
        }

      })
    }
  },
  methods: {
    ...mapActions("frontExtendConfirm", {
      update: "update"
    }),
  },
}
</script>

<template>
  <v-container>
    <v-overlay
      v-if="enableLoader"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>
